import { useState } from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import { Flex, CardFooter, ExpandableLabel, HelpIcon, useTooltip, AutoRenewIcon, Tag } from '@pancakeswap/uikit'
import { Box } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
// import ExpandedFooter from './ExpandedFooter'

interface FooterProps {
    pool: any
    account: string
    totalCakeInVault?: BigNumber
    defaultExpanded?: boolean
    setIsExpanded?: any

    isExpanded?: any

}

const PCardFooter = styled(CardFooter)`
background : #1A3342;
border-top : 1px solid #00FED9;
`
const ExpandableButtonWrapper = styled(Flex)`
  align-items: center;
  /* display:flex; */
  justify-content: space-between;
  button {
    padding: 0;
  }
`
const AutoTag = styled.div`
    align-items: center;
    border-radius: 16px;
    display: inline-flex;
    font-weight: 500;
    white-space: nowrap;
    height: 28px;
    padding: 0 8px;
    font-size: 14px;
    color: black;
    background: #00FED9;
    border: 2px solid #31D0AA;

`
// const Detail = styled.Box`
//     text-align: center;
//     justify-content: center;
//     align-items: center;
//     display: flex;
//     font-weight: 700;
//     font-size: 14px;
//     color: rgb(15, 33, 49);
// `

const Footer: React.FC<FooterProps> = ({ pool, account, defaultExpanded, setIsExpanded, isExpanded }) => {
    const { vaultKey } = pool
    // const [isExpanded, setIsExpanded] = useState(defaultExpanded || false)

    const manualTooltipText = ('You must harvest and compound your earnings from this pool manually.')
    const autoTooltipText =
        'Any funds you stake in this pool will be automagically harvested and restaked (compounded) for you.';

    const { targetRef, tooltip, tooltipVisible } = useTooltip(vaultKey ? autoTooltipText : manualTooltipText, {
        placement: 'bottom',
    })

    return (
        <PCardFooter>
            <ExpandableButtonWrapper>
                <Flex alignItems="center">
                    {/* <Tag variant="success" outline startIcon={<AutoRenewIcon width="18px" color="success" mr="4px" />} >
                        {('Auto')}
                    </Tag> */}
                    {
                        pool.stackType === 0 || pool.stackType === 1
                            ?
                            ''
                            :
                            <AutoTag>
                                <svg viewBox="0 0 24 24" fill='#000000' width="18px" color="success" xmlns="http://www.w3.org/2000/svg" className="Svg-sc-5a69fd5e-0 cSClcY"><path d="M12 6V7.79C12 8.24 12.54 8.46 12.85 8.14L15.64 5.35C15.84 5.15 15.84 4.84 15.64 4.64L12.85 1.85C12.54 1.54 12 1.76 12 2.21V4C7.58 4 4 7.58 4 12C4 13.04 4.2 14.04 4.57 14.95C4.84 15.62 5.7 15.8 6.21 15.29C6.48 15.02 6.59 14.61 6.44 14.25C6.15 13.56 6 12.79 6 12C6 8.69 8.69 6 12 6ZM17.79 8.71C17.52 8.98 17.41 9.4 17.56 9.75C17.84 10.45 18 11.21 18 12C18 15.31 15.31 18 12 18V16.21C12 15.76 11.46 15.54 11.15 15.86L8.36 18.65C8.16 18.85 8.16 19.16 8.36 19.36L11.15 22.15C11.46 22.46 12 22.24 12 21.8V20C16.42 20 20 16.42 20 12C20 10.96 19.8 9.96 19.43 9.05C19.16 8.38 18.3 8.2 17.79 8.71Z"></path></svg> Manual
                            </AutoTag>
                    }

                    {tooltipVisible && tooltip}
                    <Flex ref={targetRef}>
                        <HelpIcon ml="4px" width="20px" height="20px" color="#00FED9" />
                    </Flex>
                </Flex>
                {/* <ExpandableLabel expanded={isExpanded} onClick={() => setIsExpanded(!isExpanded)}>
                    {isExpanded ? ('Hide') : ('Details')}
                </ExpandableLabel> */}
                <Box sx={{ cursor: 'pointer' }} onClick={() => setIsExpanded((prev) => !prev)}>
                    {isExpanded ? <Box sx={{ color: '#00FED9', fontWeight: "700", justifyContent: "center", textAlign: "center", display: "flex", alignItems: "center" }}> Hide <KeyboardArrowUpIcon sx={{ height: "20px" }} /></Box> : <Box sx={{ color: '#00FED9', fontWeight: "700", justifyContent: "center", textAlign: "center", display: "flex", alignItems: "center" }}> Details <KeyboardArrowDownIcon sx={{ height: "20px" }} /></Box>}
                </Box>
            </ExpandableButtonWrapper>
            {/* {isExpanded && <ExpandedFooter pool={pool} account={account} />} */}
        </PCardFooter>
    )
}

export default Footer
